var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "big_box" }, [
    _c(
      "div",
      { staticClass: "area_header" },
      [
        _c("div", { staticClass: "selcountry_title" }, [
          _vm._v(_vm._s(_vm.$t("m.sel_country_area")))
        ]),
        _vm._v(" "),
        _c("van-search", {
          staticClass: "vant_search",
          attrs: { placeholder: _vm.$t("m.search_for") },
          on: { input: _vm.inputFouce },
          model: {
            value: _vm.value,
            callback: function($$v) {
              _vm.value = $$v
            },
            expression: "value"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "countryList" },
      [
        _c(
          "van-cell-group",
          _vm._l(_vm.countryArrSel, function(item) {
            return _c("van-cell", {
              key: item.id,
              attrs: {
                title: item.content,
                value: "+" + item.countryNum,
                icon: item.logo
              },
              on: {
                click: function($event) {
                  return _vm.selCountryInfo(item)
                }
              }
            })
          }),
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d4a1bb3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d4a1bb3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/selArea.vue
// module id = null
// module chunks = 